/***********************************************************************************
 * App entry
 *
 * @author Zip Co - Plugin Team
 *
 ***********************************************************************************/

import Vue from 'vue';
import DefaultLayout from './layouts/DefaultLayout';
import { sync } from 'vuex-router-sync';
import { createRouter } from './router';
import { createStore } from './store';

import vuetify from './plugins/Vuetify';
import('@/plugins/Axios');

export const createApp = (): any => {
    const router = createRouter();
    const store = createStore();
    const app = new Vue({
        router,
        store,
        vuetify,
        render: (h): any => h(DefaultLayout)
    });

    sync(store, router);

    return { app, router, store };
};
